export default __webpack_public_path__ + "static/media/loanOverViewSecond1.d31f536e.png";